import { Directive, forwardRef, Input } from '@angular/core';
import { AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, first, map, switchMap } from 'rxjs/operators';
import {IntegrationDao} from "../../../../core/services/dao/integrationDao";

interface NameCheckReturn {
  emailDuplicate: boolean;
}

@Directive({
  selector: '[ftpDuplicate]',
  providers: [
    { provide: NG_ASYNC_VALIDATORS, useExisting: forwardRef(() => FtpDuplicateDirective), multi: true }
  ]
})
export class FtpDuplicateDirective implements AsyncValidator {
  @Input() ftpDuplicate: Observable<string>;

  constructor(private integrationDao: IntegrationDao) {}

  validate(control: AbstractControl): Observable<ValidationErrors> {
    return this.ftpDuplicate.pipe(
      debounceTime(300), //wait for 300 ms of no user input
      distinctUntilChanged(), //only if value has changed
     // switchMap((location: string) => this.integrationDao.checkFtp(location)), //send our request but only care about the last one in flight
      map((data: any) => {
        return data.ftpDuplicate ? { ftpDuplicate: data.ftpDuplicate } : null;
      }), //transform result
      first() //You need this for displaying template driven form errors
    );
  }
}
